import { render, staticRenderFns } from "./AppDownloadQr.vue?vue&type=template&id=0224eb0c&scoped=true"
import script from "./AppDownloadQr.vue?vue&type=script&lang=js"
export * from "./AppDownloadQr.vue?vue&type=script&lang=js"
import style0 from "./AppDownloadQr.vue?vue&type=style&index=0&id=0224eb0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224eb0c",
  null
  
)

export default component.exports